<template>
  <div class="transition">
    <BasicText
      size="h5"
      class="titre-transition"
    >
      Pour quel employeur faites-vous la demande ?
    </BasicText>
    <WrapperAutocomplete
      v-model="data"
      key-id="siret.valeur"
      key-label="denomination"
      placeholder="Siren ou siret ..."
      :search-min-length="9"
      label="Etablissement effectuant la demande"
      strict
      :search
      :search-formater="sirenSiretSearchFormater"
    >
      <template v-slot="item">
        <div class="item">
          <BasicText
            weight="bold"
            size="body-m"
          >
            {{ item.denomination }}
            <BasicText
              v-if="item.estEtablissementSiege === true"
              color="primary-600"
              weight="bold"
              size="body-m"
            >
              - SIEGE
            </BasicText>
            <BasicText
              v-if="item.etatAdministratif === 'F'"
              color="red"
              size="body-m"
            >
              (Inactif)
            </BasicText>
          </BasicText>

          <BasicText size="body-s">
            {{ item.siret.siren }} {{ item.siret.nic }}
          </BasicText>
          <BasicText
            v-if="item.adresse"
            size="body-s"
            color="neutral-500"
          >
            {{ [item.adresse.voie, item.adresse.codePostal, item.adresse.commune].filter(Boolean).join(' ') }}
          </BasicText>
        </div>
      </template>
    </WrapperAutocomplete>
  </div>
</template>

<script setup lang="ts">
  import type { EtablissementAdherentDTO } from '@/features/api/extranet/dto/shared'
import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
import { sirenSiretSearchFormater } from '@/features/interface/shared/tools'
import services from '@/features/services/demande/DemandeAllService'
import { computed } from 'vue'

  const props = defineProps<CarteProps<void, EtablissementAdherentDTO>>()
  const emits = defineEmits<CarteEvents<EtablissementAdherentDTO>>()

  const data = computed<EtablissementAdherentDTO | undefined>({
    get: () => props.out,
    set: (value) => {
      const outReady = !!value?.siret?.valeur
      emits('outChanged', outReady, value)
    },
  })

  const search = (query: string) => {
    if (!/^\d{9}$|^\d{14}$/.test(query.trim())) return []
    return services.searchEtablissementAdherent(query, { dialogMode: 'silent' })
  }
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';
</style>
